import classNames from 'classnames';
import React from 'react';

const StatusHeader = ({
  options = [],
  status,
}) => {
  return (
    <div className="status-header">
      {options.map((item) => (
        <div
          key={item}
          className={classNames('status-header__item', {
            'status-header__item--active': status === item,
          })}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export default StatusHeader;
